<div>
  <mat-icon [style]="iconStyle" size="size" [ngClass]="{'is-light': isLight}">
    <ng-content></ng-content>
  </mat-icon>
  <svg [ngClass]="{'inner-shadow': innerShadow}" #circle xmlns="https://www.w3.org/2000/svg" viewBox="0 0 100 100"
       role="img" aria-label="Circle with icon inside">
    <title>Circle with icon inside</title>
    <circle cx="50" cy="50" r="50" fill="#F1F3F5" />
  </svg>
</div>
